import React from 'react';
import styles from './Studio.module.scss';
import { useIntl } from 'react-intl';
import { Badge } from '@eventbrite/legacy-eds.badge';

// NOTE: "Studio" is the product name and therefore is intentionally not translated below
export const Studio = () => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <span>Studio</span>
            <span className={styles.containerSpacing}>
                <Badge
                    text={formatMessage({ id: 'New', defaultMessage: 'New' })}
                    bgColor="success"
                />
            </span>
        </div>
    );
};
